import '../../styles/style.css';

import * as React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import {
  DatePicker,
  Dialog,
  DropDownMenu,
  FlatButton,
  MenuItem,
  RaisedButton,
  TextField,
  Toggle,
} from 'material-ui';

import EditSegmentQuery from './components/EditSegmentQuery';
import JerseyRestApiService from '../../JerseyRestApiService';
import Snackbar from 'material-ui/Snackbar';
import { StudioAppConfig } from 'glance-datatypes';
import Utils from '../../Utils';
import { connect } from 'react-redux';

const styles = {
  dialogContentStyle: {
    width: '400px',
  },
  addNewButton: {
    position: 'absolute',
    zIndex: 1,
  },
  SegmentSource: {
    marginleft: '-24px',
  },
  SegmentTarget: {
    marginLeft: '-24px',
  }
};


interface Props {
  studioAppConfig: StudioAppConfig;
}

interface State {
  segmentQuery: any[];
  segmentSources: string[],
  segmentTargets: string[],
  openSnackBar: any;
  snackBarMessage: any;
  dialogOpen: boolean;
  editDialogOpen: boolean;
  isCreating: boolean;
  name: string;
  source: string;
  target: string;
  query: string;
  startAt: any;
  endAt: any;
  expireAt: any;
  createdBy: any;
  email: string;
  selectedSegmentQuery: any;
  today: Date;
}

class SegmentQuery extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      segmentQuery: [],
      segmentSources: [],
      segmentTargets: [],
      openSnackBar: false,
      snackBarMessage: '',
      dialogOpen: false,
      editDialogOpen: false,
      isCreating: false,
      name: '',
      source: null,
      target: null,
      query: '',
      startAt: new Date(),
      endAt: new Date(),
      expireAt: null,
      createdBy: '',
      email: this.props.studioAppConfig.currentToken.user.email,
      selectedSegmentQuery: {},
      today: new Date(),
    };
  }

  componentDidMount() {
    this.setUser();
    this.getSegmentQuery();
    this.getAllSegmentSource();
    this.getAllSegmentTargets();
  }

  setUser = () => {
    if (this.props.studioAppConfig) {
      this.setState({
        ...this.state,
        createdBy: this.props.studioAppConfig.currentToken.user.name,
        email: this.props.studioAppConfig.currentToken.user.email,
      });
    }
  };

  getSegmentQuery = () => {
    JerseyRestApiService.getSegmentQueries()
      .then((response: any) => {
        this.setState({
          ...this.state,
          segmentQuery: response,
        });
      })
      .catch((err) => {
        this.setState({
          ...this.state,
          segmentQuery: [
            {
              segmentId: 'cs_d10e403fa4',
              segmentName: 'tamil subscribers',
              source: 'query',
              target: 'GLANCE FEED',
              createdAt: '2019-11-13T08:35:14.214638Z',
              updatedAt: '2019-11-13T08:35:14.214682Z',
              startAt: '2019-11-13',
              endAt: '2019-12-13',
              expireAt: '2019-13-13',
              active: false,
              query:
                "select userid from glance_analytics_prod_in.user_pq u  where enabledstate=true and contains(preferredcategories,'#tamil') and date(process_date)=DATE(CURRENT_TIMESTAMP - Interval '1' day)",
              createdBy: 'abcd',
            },
            {
              segmentId: 'cs_db5f20c267',
              segmentName: 'hindi subscribers',
              source: 'query',
              target: 'GLANCE FEED',
              createdAt: '2019-11-13T08:35:36.004438Z',
              updatedAt: '2019-11-13T08:35:36.004482Z',
              startAt: '2019-11-13',
              endAt: '2019-12-13',
              expireAt: '2019-13-13',
              active: false,
              query:
                "select userid from glance_analytics_prod_in.user_pq u  where enabledstate=true and contains(preferredcategories,'#hindi') and date(process_date)=DATE(CURRENT_TIMESTAMP - Interval '1' day)",
              createdBy: 'abcd',
            },
          ],
        });
      });
  };

  getAllSegmentSource = () => {
    JerseyRestApiService.getAllSegmentSource()
      .then((response: any) => {
        this.setState({
          ...this.state,
          segmentSources: response,
        });
      })
      .catch((err) => {
        this.setState({
          ...this.state,
          segmentSources: []
        })
      })
  }

  getAllSegmentTargets = () => {
     JerseyRestApiService.getAllSegmentTargets()
       .then((response: any) => {
         this.setState({
           ...this.state,
           segmentTargets: response,
         });
       })
       .catch((err) => {
         this.setState({
           ...this.state,
           segmentTargets: []
         })
       })
  }

  handleClose = () => {
    this.setState({
      ...this.state,
      dialogOpen: false,
    });
  };

  handleEditClose = () => {
    this.setState({
      ...this.state,
      editDialogOpen: false,
    });
  };

  handleSnackbarClose = () => {
    this.setState({
      ...this.state,
      openSnackBar: false,
    });
  };

  showSnackbarMessage = (message: string) => {
    this.setState({
      ...this.state,
      openSnackBar: true,
      snackBarMessage: message,
    });
  }

  reset = () => {
    const { today } = this.state;
    this.setState({
      ...this.state,
      dialogOpen: false,
      name: '',
      source: null,
      target: null,
      query: '',
      startAt: today,
      endAt: today,
      expireAt: null,
    });
  };

  openCreateSegmentQueryModal = () => {
    this.setState({
      ...this.state,
      dialogOpen: true,
    });
  };

  createSegmentQuery = () => {
    const { name, source, query ,target , startAt, endAt, expireAt, createdBy, email} = this.state;
    if (!source) {
      this.setState({
        ...this.state,
        openSnackBar: true,
        snackBarMessage: 'Please select query source',
      });
      return;
    } else if ((source === "query" || source === "staticquery") && !query) {
      this.setState({
        ...this.state,
        openSnackBar: true,
        snackBarMessage: `Query field is mandatory for ${source} source.`,
      })
      return;
    }
    this.setState({
      ...this.state,
      openSnackBar: true,
      snackBarMessage: 'Creating new segment query...',
    });

    let expiry: Date;
    if (source !== "staticquery") {
      expiry = new Date(endAt);
      expiry.setDate(expiry.getDate() + 1);
    } else if (expireAt) {
      expiry = new Date(expireAt);
    } else {
      this.setState({
        ...this.state,
        openSnackBar: true,
        snackBarMessage: 'Expiry Date is Mandatory for Static query',
      });
      return;
    }

    if (!email) {
      this.setState({
        ...this.state,
        openSnackBar: true,
        snackBarMessage: 'Email field is mandatory for all sources.',
      })
      return;
    }

    if (!target) {
          this.setState({
            ...this.state,
            openSnackBar: true,
            snackBarMessage: 'Please select query target.',
          })
          return;
    }

    const payload = {
      segmentName: name,
      source,
      target,
      query: query.replace(/[\r\n]+/gm, ' '),
      startAt: Utils.getDateInYyyyMmDd(startAt),
      endAt: Utils.getDateInYyyyMmDd(endAt),
      expireAt: Utils.getDateInYyyyMmDd(expiry),
      email,
      createdBy,
    };
    JerseyRestApiService.addSegmentQuery(payload)
      .then((response: any) => {
        this.setState({
          ...this.state,
          dialogOpen: false,
          source: null,
          target:null,
          name: '',
          query: '',
          snackBarMessage: response.segmentId + ' successfully created',
        });
        this.getSegmentQuery();
        this.reset();
      })
      .catch((err) => {
        this.reset();
      });
  };

  updateSegmentQuery = (payload) => {
    JerseyRestApiService.updateSegmentQuery(payload)
      .then((response: any) => {
        this.setState({
          ...this.state,
          editDialogOpen: false,
          snackBarMessage: response.segmentId + ' successfully Updated',
        });
        this.getSegmentQuery();
        this.reset();
      })
      .catch((err) => {
        this.reset();
      });
  };

  onSegmentQueryChange = (key: any, value: any) => {
    this.setState({
      ...this.state,
      [key]: value,
    });
  };

  formatStatus = (cell: any) => {
    return cell ? 'Active' : 'Inactive';
  };

  formatOverflow = (cell: any) => {
    return (
      <div
        style={{
          overflow: 'visible',
          whiteSpace: 'normal',
        }}
      >
        {cell}
      </div>
    );
  };

  onClickProductSelected = (cell, row, rowIndex) => {
    console.log('Product : ', row);
    this.setState({
      ...this.state,
      editDialogOpen: true,
      selectedSegmentQuery: row,
    });
  };

  cellButton = (cell, row, enumObject, rowIndex) => {
    return (
      <div
        style={{
          overflow: 'visible',
          whiteSpace: 'normal',
          color: 'rgb(0, 188, 212)',
          cursor: 'pointer',
        }}
        onClick={() => this.onClickProductSelected(cell, row, rowIndex)}
      >
        {cell}
      </div>
    );
  };

  handleRunDate = (value: Date) => {
    this.setState({
      ...this.state,
      startAt: value,
      endAt: value
    });
  }

  addMonths = (value: Date) =>{
    let date = new Date(value);
    date.setMonth(date.getMonth()+3);
    return date;
  }

  handleSourceChange = (value: string) =>{
    this.setState({
      ...this.state,
      endAt: this.state.startAt,
      expireAt: null,
      source: value
    });
  }

  handleTargetChange = (value: string) =>{
      this.setState({
        ...this.state,
        endAt: this.state.startAt,
        expireAt: null,
        target: value
      });
    }

  render() {
    const {
      segmentQuery,
      segmentSources,
      segmentTargets,
      dialogOpen,
      editDialogOpen,
      isCreating,
      name,
      source,
      target,
      query,
      startAt,
      endAt,
      expireAt,
      email,
      selectedSegmentQuery,
      today,
    } = this.state;
    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onTouchTap={this.handleClose}
      />,
      <FlatButton
        label="Create"
        primary={true}
        onTouchTap={this.createSegmentQuery}
        disabled={isCreating}
      />,
    ];
    return (
      <div style={{ marginTop: '40px', width: '100%' }}>
        <div style={styles.addNewButton}>
          <RaisedButton
            primary={true}
            label="Add New Query"
            onTouchTap={this.openCreateSegmentQueryModal}
          />
        </div>
        <div>
          <BootstrapTable
            ref="table"
            data={segmentQuery}
            hover
            search={{ type: 'TextSearch' }}
            pagination={true}
          >
            <TableHeaderColumn
              isKey={true}
              dataField="segmentId"
              width="10%"
              height="100px"
              dataFormat={this.cellButton.bind(this)}
            >
              Segment ID
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="segmentName"
              width="12%"
              dataFormat={this.formatOverflow}
            >
              Segment Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="startAt"
              width="10%"
              dataFormat={this.formatOverflow}
            >
              Start At
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="endAt"
              width="10%"
              dataFormat={this.formatOverflow}
            >
              End At
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="expireAt"
              width="10%"
              dataFormat={this.formatOverflow}
            >
              Expiry Date
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="active"
              dataFormat={this.formatStatus}
              width="8%"
            >
              Status
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="createdBy"
              width="10%"
              dataFormat={this.formatOverflow}
            >
              Created By
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="source"
              width="8%"
              dataFormat={this.formatOverflow}
            >
              Source
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="target"
              width="8%"
              dataFormat={this.formatOverflow}
            >
              Target
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="query"
              width="30%"
              dataFormat={this.formatOverflow}
            >
              Query
            </TableHeaderColumn>
          </BootstrapTable>
          <Snackbar
            open={this.state.openSnackBar}
            message={this.state.snackBarMessage}
            autoHideDuration={2000}
          />
        </div>
        <Dialog
          actions={actions}
          modal={false}
          open={dialogOpen}
          onRequestClose={this.handleClose}
          autoScrollBodyContent={true}
          contentStyle={styles.dialogContentStyle}
        >
          <TextField
            id="segmentName"
            fullWidth={true}
            value={name}
            floatingLabelText="Segment Name"
            onChange={(e, value) => this.onSegmentQueryChange('name', value)}
          />
          <DropDownMenu
            value={target}
            onChange={(field, context, value) => this.handleTargetChange(value)}
            className="dropDownMenu"
          >
            <MenuItem value={null} primaryText="Select Target" />
            {segmentTargets
              .map((segmentTarget) => {
                return (
                  <MenuItem
                    key={`target-${segmentTarget}`}
                    value={segmentTarget}
                    primaryText={segmentTarget}
                  />
                );
              })}
          </DropDownMenu>
          <DropDownMenu
            value={source}
            onChange={(field, context, value) => this.handleSourceChange(value)}
            className="dropDownMenu"
          >
            <MenuItem value={null} primaryText="Select Source" />
            {segmentSources
              .map((segmentSource) => {
                return (
                  <MenuItem
                    key={`source-${segmentSource}`}
                    value={segmentSource}
                    primaryText={segmentSource}
                  />
                );
              })}
          </DropDownMenu>
          {this.state.source != "staticquery" ?
          <div>
            <div>Starts At:</div>
            <DatePicker
            value={startAt}
            minDate={today}
            hintText="Starts At"
            container="inline"
            fullWidth={true}
            onChange={(e, value) => this.onSegmentQueryChange('startAt', value)}
          />
          <div>Ends At:</div>
          <DatePicker
            value={endAt}
            minDate={startAt}
            maxDate={this.addMonths(today)}
            hintText="Ends At"
            container="inline"
            fullWidth={true}
            onChange={(e, value) => this.onSegmentQueryChange('endAt', value)}
          />
          </div>
         :
         <div>
           <div>Run Date:</div>
           <DatePicker
            value={startAt}
            minDate={today}
            hintText="Run Date"
            container="inline"
            fullWidth={true}
            onChange={(_e, value) => this.handleRunDate(value)}
          />
          <div>Expiry Date:</div>
          <DatePicker
            value={expireAt}
            minDate={today}
            maxDate={this.addMonths(today)}
            container="inline"
            fullWidth={true}
            onChange={(_e, value) => this.onSegmentQueryChange('expireAt', value)}
            disabled={this.state.source != "staticquery" ? true : false}
          />
          </div>}
          <TextField
            id="createQuery"
            floatingLabelText="Query"
            value={query}
            multiLine={true}
            rows={3}
            fullWidth={true}
            rowsMax={4}
            onChange={(e, value) => this.onSegmentQueryChange('query', value)}
          />
          <TextField
            id="createEmail"
            fullWidth={true}
            value={email}
            floatingLabelText="Email Address"
            onChange={(e, value) => this.onSegmentQueryChange('email', value)}
          />
          <Toggle label="Status" toggled={false} disabled={true} />
        </Dialog>
        <EditSegmentQuery
          editDialogOpen={editDialogOpen}
          handleClose={this.handleEditClose}
          updateSegmentQuery={this.updateSegmentQuery}
          segmentQueryData={selectedSegmentQuery}
          showSnackbarMessage={this.showSnackbarMessage}
          addMonths={this.addMonths}
          today={today}
        />
        <Snackbar
          open={this.state.openSnackBar}
          message={this.state.snackBarMessage}
          onRequestClose={this.handleSnackbarClose}
          autoHideDuration={2000}
        />
      </div >
    );
  }
}

const mapStateToProps = (state) => {
  return {
    studioAppConfig: state.studioAppConfig,
  };
};

export default connect(mapStateToProps)(SegmentQuery);



// WEBPACK FOOTER //
// ./src/pages/segmentQuery/index.tsx